angular.module('spaceChat.common')
   .factory('spaceChatUploadSvc', [ 'IHestiaRestServiceAbstractDef',
    function(IHestiaRestServiceAbstractDef) {

    var SpaceChatUpload = function()
    {
      IHestiaRestServiceAbstractDef.apply(this, arguments);

      this.basePattern = '{host}{port}{path}/{businessArea}/{apiString}/{resource}{id}{subResource}';
      this.businessArea = 'space-chat';
      this.resource = 'chat';
      this.dataType = 'file';
    };

    return new SpaceChatUpload();
  }])
;